import PropTypes from "prop-types";
import React from "react";
import _get from "lodash/get";
import { FieldLabel, RemoteSelectField } from "react-invenio-forms";
import { i18next } from "@translations/up/i18next";

const serializeSuggestions = (suggestions) => {
  return suggestions.map((item) => ({
    text: item.title_l10n ?? item.title?.en ?? item.id,
    value: item.id,
    key: item.id,
  }));
};

export const DegreeNameField = ({ fieldPath, label, placeholder, record }) => {
  const degreeNameValue = _get(
    record,
    "ui.custom_fields.ubiquity:thesis.degree_name"
  );

  // Ensure the initial value has the proper structure with title_l10n
  const initialSuggestions = degreeNameValue
    ? [
        {
          ...degreeNameValue,
          title_l10n:
            degreeNameValue.title_l10n ??
            degreeNameValue.title?.en ??
            degreeNameValue.id,
        },
      ]
    : [];

  return (
    <RemoteSelectField
      fieldPath={fieldPath}
      suggestionAPIUrl="/api/vocabularies/thesisdegreenames"
      suggestionAPIHeaders={{
        Accept: "application/vnd.inveniordm.v1+json",
      }}
      initialSuggestions={initialSuggestions}
      serializeSuggestions={serializeSuggestions}
      placeholder={placeholder}
      label={<FieldLabel htmlFor={fieldPath} label={label} />}
      noQueryMessage={i18next.t("Search for degree names..")}
      clearable
      search
    />
  );
};

DegreeNameField.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object.isRequired,
};

DegreeNameField.defaultProps = {
  placeholder: "",
  label: "",
};
